import { Common, ApiBind } from './common.model';

export class PlacementAsset extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'type' })
  type: number;

  @ApiBind({ column: 'value' })
  value: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;
}
